import React from 'react'
import ReactDOM from 'react-dom'

import MaxStat from './containers/MaxStat'

const removeLoadingState = () => {
  const container = document.getElementsByClassName('charts')?.[0]
  container.classList.remove('charts--loading')
}

ReactDOM.render(<MaxStat />, document.getElementById('charts'), removeLoadingState)
